module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCIgaWQ9ImZsYWctaWNvbi1jc3MtcnUiPgogIDxnIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIxcHQiPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDAzOWE2IiBkPSJNMCAxNjAuMDAzaDY0MFY0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNkNTJiMWUiIGQ9Ik0wIDMxOS45OTdoNjQwVjQ4MEgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/language-icons/ru.svg
// module id = 7pwQ
// module chunks = 1